import { render } from "./VacanciesDepartments.vue?vue&type=template&id=7ddd5b38"
import script from "./VacanciesDepartments.vue?vue&type=script&lang=js"
export * from "./VacanciesDepartments.vue?vue&type=script&lang=js"

import "./VacanciesDepartments.vue?vue&type=style&index=0&id=7ddd5b38&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__